import { InitUserRole, useUserInitAccess, UUID } from "@gx1/gx-npm-lib";
import { PlainTooltipComponent, TertiaryButtonComponent } from "@gx1/gx-ui-common";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { navigateToUrl } from "single-spa";
import styles from "./manage-team-btn.styles.module.scss";
import { useLocation } from "react-router";
import { GroupAddIconOutlineV2 } from "./group-add-outline-v2.icon";

const ManageTeamBtnComponent = () => {
  const { t } = useTranslation();
  const { initiativeId = "" } = useParams<{ initiativeId: UUID; tab: string }>();
  const { role } = useUserInitAccess(initiativeId);
  const { pathname } = useLocation();

  const handleClickShare = () => {
    if (window.Intercom) {
      const metadata = { event: "User clicked Share button" };
      window.Intercom("trackEvent", "share-button", metadata);
    }
    navigateToUrl(`${pathname}/team-management`);
  };

  return (
    <div className={styles.root}>
      <PlainTooltipComponent
        additionalProps={{ placement: "left" }}
        deactivate={role === InitUserRole.OWNER}
        title={t("This action is only available to evaluation owners.")}
      >
        <TertiaryButtonComponent
          isDisabled={role !== InitUserRole.OWNER}
          onClick={handleClickShare}
          size="small"
        >
          <span className={styles.btn}>
            <GroupAddIconOutlineV2 />
            {t("Manage Team")}
          </span>
        </TertiaryButtonComponent>
      </PlainTooltipComponent>
    </div>
  );
};

export default ManageTeamBtnComponent;
